module.exports = {"hero":{"title":"Keep on top of the HR trends with us!","subtitle":"Keep up to date on lastest trends and updates with all things HR. Check out our most recent post below and subscribe to our blog so you can <span class='no-break-text'>stay updated.</span>"},"recommended":"Our recommended articles","read-articles-in":"I want to read articles in","all-categories":"All categories","blog-articles":"Blog Articles","subscribe":{"title":"Sign up for our email updates <span class='no-break-text'>and stay updated</span>"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/blog.json
// module id = hrPa
// module chunks = 0